(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sa-rn-v11"]) return;
  try {
    
(function () {
  var formIds = ['richiesta-aziendale', 'richiesta-aziendale-bottom'];
  var payloadKey = 'sa_b2b_christmas_lead_payload';
  var dedupeKey = 'sa_b2b_christmas_lead_sent:' + window.location.pathname;

  function val(form, selector) {
    var el = form.querySelector(selector);
    return el && typeof el.value === 'string' ? el.value.trim() : '';
  }

  function checked(form, selector) {
    var el = form.querySelector(selector);
    return !!(el && el.checked);
  }

  formIds.forEach(function (id) {
    var form = document.getElementById(id);
    if (!form) return;

    form.addEventListener('submit', function (event) {
      var trap = form.querySelector('[name="website"]');
      if (trap && trap.value) {
        event.preventDefault();
        return;
      }

      var p = {
        email: val(form, '[name="contact[email]"]'),
        name: val(form, '[name="contact[name]"]'),
        company: val(form, '[name="contact[Azienda]"]'),
        phone: val(form, '[name="contact[Telefono]"]'),
        quantity: val(form, '[name="contact[Quantità]"]'),
        budget: val(form, '[name="contact[Budget]"]'),
        catalog: checked(form, '[name="contact[Catalogo completo]"]'),
        capturedAt: new Date().toISOString()
      };

      try {
        window.sessionStorage.removeItem(dedupeKey);
        window.sessionStorage.setItem(payloadKey, JSON.stringify(p));
      } catch (e) {}
    });
  });

  document.addEventListener('click', function (event) {
    var copyButton = event.target.closest('[data-copy-email]');
    if (copyButton && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText('info@sicilyaddict.it').then(function () {
        var status = document.getElementById('sa-copy-status');
        if (status) {
          status.textContent = 'Email copiata: info@sicilyaddict.it';
          status.hidden = false;
          window.setTimeout(function () { status.hidden = true; }, 2200);
        }
      }).catch(function () {});
    }

    var infoLink = event.target.closest('[data-info]');
    if (infoLink) {
      var target = document.getElementById('info-' + infoLink.getAttribute('data-info'));
      if (target && target.tagName === 'DETAILS') target.open = true;
    }
  });

  var success = document.querySelector('[data-sa-native-success="true"]');
  if (!success) return;

  ['form-status', 'form-status-bottom'].forEach(function (id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.textContent = 'Richiesta inviata correttamente. Il team SicilyAddict ti ricontatterà ai recapiti indicati.';
    el.hidden = false;
  });

  try {
    if (window.sessionStorage.getItem(dedupeKey) === '1') return;
    window.sessionStorage.setItem(dedupeKey, '1');
  } catch (e) {}

  var p = null;
  try {
    p = JSON.parse(window.sessionStorage.getItem(payloadKey) || 'null');
  } catch (e) {}

  var leadData = {
    lead_type: 'regali_aziendali_natale',
    lead_source: 'shopify_contact_form',
    page_path: window.location.pathname,
    page_title: document.title
  };

  if (p && p.email) {
    var profile = {
      email: p.email,
      'B2B Regali Aziendali Lead': true,
      'Lead Source': 'Landing Regali Aziendali Natale 2026',
      'Lead Captured At': p.capturedAt || new Date().toISOString(),
      'Catalogo richiesto': !!p.catalog
    };
    if (p.name) profile['Nome e cognome'] = p.name;
    if (p.company) profile.organization = p.company;
    if (p.phone) profile.Telefono = p.phone;
    if (p.quantity) profile['Quantità'] = p.quantity;
    if (p.budget) profile.Budget = p.budget;

    var klaviyoEvent = {
      'Lead Source': 'Landing Regali Aziendali Natale 2026',
      'Lead Type': 'B2B Regali Aziendali',
      'Azienda': p.company || '',
      'Quantità': p.quantity || '',
      'Budget': p.budget || '',
      'Catalogo richiesto': !!p.catalog,
      'Page Path': window.location.pathname
    };

    var klaviyoAttempts = 0;
    function sendKlaviyoLead() {
      klaviyoAttempts += 1;

      if (window.klaviyo &&
          typeof window.klaviyo.identify === 'function' &&
          typeof window.klaviyo.track === 'function') {
        try {
          var identifyResult = window.klaviyo.identify(profile);
          if (identifyResult && typeof identifyResult.then === 'function') {
            identifyResult
              .then(function () {
                return window.klaviyo.track('B2B Regali Aziendali - Lead', klaviyoEvent);
              })
              .catch(function () {});
          } else {
            window.klaviyo.track('B2B Regali Aziendali - Lead', klaviyoEvent);
          }
        } catch (e) {}
        return;
      }

      if (klaviyoAttempts < 40) {
        window.setTimeout(sendKlaviyoLead, 250);
      }
    }
    sendKlaviyoLead();
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'generate_lead',
    lead_type: leadData.lead_type,
    lead_source: leadData.lead_source,
    page_path: leadData.page_path,
    page_title: leadData.page_title
  });

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'generate_lead', {
      lead_type: leadData.lead_type,
      lead_source: leadData.lead_source
    });
  }

  try {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish('sa_b2b_generate_lead', leadData);
    }
  } catch (e) {}

  var metaAttempts = 0;
  function sendMetaLead() {
    metaAttempts += 1;
    var allowed = false;
    try {
      allowed = !!(window.Shopify && window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.marketingAllowed === 'function' &&
        window.Shopify.customerPrivacy.marketingAllowed());
    } catch (e) {}

    if (allowed && typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', {
        content_name: 'Regali aziendali Natale 2026',
        content_category: 'B2B'
      });
      return;
    }
    if (metaAttempts < 12) window.setTimeout(sendMetaLead, 250);
  }
  sendMetaLead();

  try { window.sessionStorage.removeItem(payloadKey); } catch (e) {}
})();

  } catch(e) { console.error(e); }
})();
})();
